import { defaultsDeep } from 'lodash-es'
import template from 'lodash-es/template'

import { useAuthStore } from '@/feature/auth/store/auth'

import {
  NetworkParams,
  SWROptions,
  usePaginatedNetworkResource,
} from '@/lib/core/hooks/usePaginatedNetworkResource'
import { ListFilters, PaginatedList, ResponseError } from '@/lib/core/interfaces/common.types'

export const createPaginatedNetworkRequestHook = <
  DataType,
  RequestPayload extends NetworkParams<ListFilters> | null = NetworkParams<ListFilters> | null,
  Response extends PaginatedList<DataType> = PaginatedList<DataType>,
  Error = ResponseError,
  SWRConfig extends SWROptions<Response, Error> = SWROptions<Response, Error>,
>(
  baseUrl: string,
  defaultConfig: Partial<SWRConfig> = {},
) => {
  const urlTemplate = template(baseUrl)
  return (params?: RequestPayload | null, swrOptions?: SWRConfig) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

    return usePaginatedNetworkResource<DataType, RequestPayload | null, Response, Error, SWRConfig>(
      params === null || !isAuthenticated ? null : urlTemplate({ params }),
      { params },
      defaultsDeep(swrOptions, defaultConfig),
    )
  }
}
